/**
 * Zod schema for dropdown / select (dd, tags-dd) fields.
 * Messages: Required "Select an option.", Invalid selection "This option is no longer available."
 */

import { z } from 'zod';
import type { FieldSchemaConfig } from '../types';

const idLabelObject = z
  .object({
    id: z.union([z.number(), z.string()]),
    label: z.string().optional(),
    name: z.string().optional(),
  })
  .nullable();

export function getDropdownSchema(col: FieldSchemaConfig): z.ZodTypeAny {
  const required = 'required' in col && col.required === true;
  const allowedOptionIds = col.allowedOptionIds;

  let schema: z.ZodTypeAny = idLabelObject;

  if (required) {
    schema = schema.refine((v: { id?: unknown } | null) => {
      if (v == null) return false;
      const id = v.id;
      return id !== undefined && id !== '' && id !== null;
    }, 'Select an option.') as z.ZodTypeAny;
  }

  if (allowedOptionIds != null && allowedOptionIds.length > 0) {
    const set = new Set(allowedOptionIds.map(String));
    schema = schema.refine((v: { id?: unknown } | null) => {
      if (v == null) return true;
      const id = v.id;
      if (id === undefined || id === null || id === '') return true;
      return set.has(String(id));
    }, 'This option is no longer available.') as z.ZodTypeAny;
  }

  return schema;
}
